import { Select, SelectProps } from "antd";
import { useEffect, useState } from "react";
import { useSettingsServiceListPaymentMethods, useSettingsServiceListPaymentMethodsKey } from "api/queries";
import qs from "query-string";

interface IPaymentMethodSelectProps {
  isForm?: boolean;
  onChange?: (value: any) => void;
  value?: string | number | null;
  items?: any[];
  selectProps?: Partial<SelectProps>;
}

const PaymentMethodSelectWithForm: React.FC<IPaymentMethodSelectProps> = ({
  value,
  onChange,
  ...rest
}) => {
  const [filters, setFilters] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const { data, isLoading, isRefetching, refetch } =
    useSettingsServiceListPaymentMethods(
      {
        pagination: qs.stringify({ limit: 100, page: 1 }),
        filters,
        sort: "",
        searchQuery,
      },
      [useSettingsServiceListPaymentMethodsKey]
    );

  const handleFilter = (value: string) => {
    setFilters(
      value
        ? qs.stringify({
            paymentMethodName: {
              $ilike: `${value}%`,
            },
          })
        : ""
    );
    setSearchQuery(value);
  };

  useEffect(() => {
    refetch();
  }, [filters, searchQuery, refetch]);

  return (
    <Select
      value={value}
      onChange={(v) => {
        //@ts-ignore
        onChange?.(v);
      }}
      showSearch
      allowClear
      loading={isLoading || isRefetching}
      placeholder="Select a payment method"
      notFoundContent={false}
      defaultActiveFirstOption={false}
      defaultValue={null}
      filterOption={false}
      options={
        data?.items?.map((_v: any) => {
          return {
            label: _v.paymentMethodName,
            value: _v.idPaymentMethod,
            key: _v.idPaymentMethod + "-payment-method-select",
          };
        }) ?? []
      }
      onSearch={handleFilter}
      {...rest.selectProps}
    />
  );
};

const PaymentMethodSelectNoForm: React.FC<IPaymentMethodSelectProps> = ({
  value,
  onChange,
  ...rest
}) => {
  const [filters, setFilters] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const { data, isLoading, isRefetching, refetch } =
    useSettingsServiceListPaymentMethods(
      {
        pagination: qs.stringify({ limit: 100, page: 1 }),
        filters,
        sort: "",
        searchQuery,
      },
      [useSettingsServiceListPaymentMethodsKey]
    );

  const handleFilter = (value: string) => {
    setFilters(
      value
        ? qs.stringify({
            paymentMethodName: {
              $ilike: `${value}%`,
            },
          })
        : ""
    );
    setSearchQuery(value);
  };

  useEffect(() => {
    refetch();
  }, [filters, searchQuery, refetch]);

  return (
    <Select
      value={value}
      onChange={(v) => {
        //@ts-ignore
        onChange?.(v);
      }}
      showSearch
      allowClear
      loading={isLoading || isRefetching}
      placeholder="Select a payment method"
      notFoundContent={false}
      defaultActiveFirstOption={false}
      defaultValue={null}
      filterOption={false}
      options={
        data?.items?.map((_v: any) => {
          return {
            label: _v.paymentMethodName,
            value: _v.idPaymentMethod,
            key: _v.idPaymentMethod + "-payment-method-select",
          };
        }) ?? []
      }
      onSearch={handleFilter}
      {...rest.selectProps}
    />
  );
};

const PaymentMethodSelect: React.FC<IPaymentMethodSelectProps> = ({ isForm, ...rest }) => {
  if (isForm) {
    return <PaymentMethodSelectWithForm {...rest} />;
  }
  return <PaymentMethodSelectNoForm {...rest} />;
};

export default PaymentMethodSelect;